import { ParamsPanel } from '../ParamsPanel/ParamsPanel.js';

import type { HeadersPanelProps } from './HeadersPanel.interface.js';

export function HeadersPanel({ headers, onChange }: HeadersPanelProps) {
  return (
    <ParamsPanel
      pairs={headers}
      onChange={onChange}
      placeholder={{ key: 'Header name', value: 'Header value' }}
    />
  );
}
